import { CognitoIdentityProviderClient } from "@aws-sdk/client-cognito-identity-provider";

interface AWSConfig {
    region: string;
    clientId: string;
    userPoolId: string;
    apiBaseUrl: string;
    environment: string;
}

// Get current environment
// Priority: REACT_APP_ENV > NODE_ENV > hostname detection > default
const getEnvironment = (): string => {
    // 1. Check explicit environment variable
    if (process.env.REACT_APP_ENV) {
        return process.env.REACT_APP_ENV;
    }

    // 2. Check NODE_ENV
    if (process.env.NODE_ENV === 'production') {
        // In production build, detect from hostname
        if (typeof window !== 'undefined') {
            const hostname = window.location.hostname;
            if (hostname.includes('beta') || hostname.includes('staging')) {
                return 'beta';
            }
            if (hostname.includes('dev')) {
                return 'dev';
            }
            return 'production';
        }
        return 'production';
    }

    // 3. Default to development
    return 'development';
};

const environment = getEnvironment();

// Validate required environment variables
const validateConfig = () => {
    const required = ['REACT_APP_COGNITO_CLIENT_ID', 'REACT_APP_COGNITO_USER_POOL_ID'];
    const missing = required.filter(key => !process.env[key]);

    if (missing.length > 0) {
        console.error(`Missing required environment variables: ${missing.join(', ')}`);
        console.error('Please check your .env file');
    }
};

validateConfig();

export const AWS_CONFIG: AWSConfig = {
    region: process.env.REACT_APP_AWS_REGION || 'ap-southeast-2',
    clientId: process.env.REACT_APP_COGNITO_CLIENT_ID || '',
    userPoolId: process.env.REACT_APP_COGNITO_USER_POOL_ID || '',
    apiBaseUrl: process.env.REACT_APP_API_BASE_URL || 'https://api.dev.loopsafe.live',
    environment: environment,
};

// Log configuration in development (helps with debugging)
// if (environment === 'development') {
    // console.log('AWS Config:', {
    //     environment: AWS_CONFIG.environment,
    //     region: AWS_CONFIG.region,
    //     clientId: AWS_CONFIG.clientId ? `${AWS_CONFIG.clientId.substring(0, 10)}...` : 'NOT SET',
    //     userPoolId: AWS_CONFIG.userPoolId ? `${AWS_CONFIG.userPoolId.substring(0, 10)}...` : 'NOT SET',
    //     apiBaseUrl: AWS_CONFIG.apiBaseUrl,
    // });
// }

// Initialize the Cognito client
export const cognitoClient = new CognitoIdentityProviderClient({
    region: AWS_CONFIG.region,
});